module.exports = __webpack_public_path__ + "static/img/hotwindTop.185de22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotwindTop.png
// module id = 7Ihr
// module chunks = 2